import { Button as AntButton, ButtonProps as AntButtonProps } from 'antd'

export type ButtonProps = AntButtonProps

const Button = (props: ButtonProps) => {
    return (
        <AntButton {...props} size="middle">
            {props.children}
        </AntButton>
    )
}

export default Button
